export default __webpack_public_path__ + "img/WB_RT_250MA_BF.aceb28c93b6cab2ddaecffcfb564856b.jpg";